import { render, staticRenderFns } from "./updateOrCreateProjectChecklist.vue?vue&type=template&id=50f7cb24"
import script from "./updateOrCreateProjectChecklist.vue?vue&type=script&lang=js"
export * from "./updateOrCreateProjectChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports